import { render, staticRenderFns } from "./SweetAlertPosition.vue?vue&type=template&id=a382ffc0&"
import script from "./SweetAlertPosition.vue?vue&type=script&lang=js&"
export * from "./SweetAlertPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports